import { menuGroup, menuItem } from "modules/helpers";

// components
import Routing from "./Routing.doc";
import RoutingPrivateRoute from "./RoutingPrivateRoute.doc";
import RoutingPublicRoute from "./RoutingPublicRoute.doc";
import RoutingRedirect from "./RoutingRedirect.doc";
import RoutingRoute from "./RoutingRoute.doc";
import RoutingSubRoutes from "./RoutingSubRoutes.doc";

const components = [
  menuItem("<Routing/>", "routing", Routing),
  menuItem(
    "<Routing.PrivateRoute/>",
    "routing-private-route",
    RoutingPrivateRoute
  ),
  menuItem(
    "<Routing.PublicRoute/>",
    "routing-public-route",
    RoutingPublicRoute
  ),
  menuItem("<Routing.Redirect/>", "routing-redirect", RoutingRedirect),
  menuItem("<Routing.Route/>", "routing-route", RoutingRoute),
  menuItem("<Routing.SubRoutes/>", "routing-sub-routes", RoutingSubRoutes),
];

export default [menuGroup("Components", "components", components)];
